import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { PolicyPipesModule } from '@amfam/policy/pipes';
import { PolicySharedModule } from '@amfam/policy/shared';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { RiskListModule } from '@amfam/shared/ui/risk-list';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { AgentSelectionModalComponent } from './agent-selection-modal/agent-selection-modal.component';
import { CategorySelectionListComponent } from './category-selection-list/category-selection-list.component';
import { CoverageSelectComponent } from './coverages-page/coverage-select/coverage-select.component';
import { IncludedCoveragesComponent } from './coverages-page/included-coverages/included-coverages.component';
import { IncludedDiscountsListComponent } from './coverages-page/included-discounts-list/included-discounts-list.component';
import { DiscountsListComponent } from './coverages-page/optional-discounts-list/optional-discounts-list.component';
import { OutOfPocketCoveragesComponent } from './coverages-page/out-of-pocket-coverages/out-of-pocket-coverages.component';
import { QuoteSidebarComponent } from './coverages-page/quote-sidebar/quote-sidebar.component';
import { DriverAssignmentComponent } from './driver-assignment/driver-assignment.component';
import { EquipmentChecklistComponent } from './equipment-checklist/equipment-checklist.component';
import { EquipmentListComponent } from './equipment-list/equipment-list.component';
import { EquipmentSelectionItemComponent } from './equipment-selection-item/equipment-selection-item.component';
import { EquipmentSelectionListComponent } from './equipment-selection-list/equipment-selection-list.component';
import { ExitFlowModalComponent } from './exit-flow-modal/exit-flow-modal.component';
import { GarageListComponent } from './garage-list/garage-list.component';
import { GracePeriodComponent } from './grace-period/grace-period.component';
import { TransformCoveragesPipe } from './pipes/transform-coverages.pipe';
import { VehicleAssignmentModalComponent } from './vehicle-assignment-modal/vehicle-assignment-modal.component';
import { VehicleAssignmentComponent } from './vehicle-assignment/vehicle-assignment.component';
import { WrapSectionComponent } from './wrap-section/wrap-section.component';

@NgModule({
  imports: [
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    RouterModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    ImpersonationModule,
    DsRouterLinkModule,
    BrandDirectivesModule,
    PolicyPipesModule,
    RiskListModule,
    PolicySharedModule
  ],
  declarations: [
    AgentSelectionModalComponent,
    CoverageSelectComponent,
    DiscountsListComponent,
    DriverAssignmentComponent,
    EquipmentChecklistComponent,
    EquipmentListComponent,
    EquipmentSelectionItemComponent,
    EquipmentSelectionListComponent,
    ExitFlowModalComponent,
    GarageListComponent,
    GracePeriodComponent,
    IncludedCoveragesComponent,
    OutOfPocketCoveragesComponent,
    VehicleAssignmentComponent,
    IncludedDiscountsListComponent,
    QuoteSidebarComponent,
    VehicleAssignmentModalComponent,
    WrapSectionComponent,
    TransformCoveragesPipe,
    CategorySelectionListComponent
  ],
  exports: [
    AgentSelectionModalComponent,
    CoverageSelectComponent,
    CategorySelectionListComponent,
    DiscountsListComponent,
    DriverAssignmentComponent,
    EquipmentChecklistComponent,
    EquipmentListComponent,
    EquipmentSelectionItemComponent,
    EquipmentSelectionListComponent,
    ExitFlowModalComponent,
    GarageListComponent,
    GracePeriodComponent,
    IncludedCoveragesComponent,
    OutOfPocketCoveragesComponent,
    VehicleAssignmentComponent,
    IncludedDiscountsListComponent,
    QuoteSidebarComponent,
    VehicleAssignmentModalComponent,
    TransformCoveragesPipe
  ]
})
export class PolicyAddVehicleUiModule {}
